mutation UpdateEmoteWallYouTubeChannels($emoteWallId: ID!, $youtubeChatChannels: [String!]!) {
  wall: StreamToolsUpdateEmoteWall(emoteWallId: $emoteWallId, youtubeChatChannels: $youtubeChatChannels) {
    emoteWallId
    name
    twitchChatChannels
    style
    emoteSize
    density
    durationSeconds
    showTwitchEmotes
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    youtubeChatChannels
    blockedWords
    createdAt
  }
}
